package com.anjuros.website.templates.template10.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.EMAIL_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.MESSAGE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.template10.components.Template10Eyebrow
import com.anjuros.website.templates.template10.components.Template10Reveal
import com.anjuros.website.templates.template10.components.Template10Seal
import com.anjuros.website.templates.template10.components.template10BodyFont
import com.anjuros.website.templates.template10.components.template10HeadingFont
import com.anjuros.website.templates.template10.modules.Template10Section
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.modules.Template10Venue
import com.anjuros.website.templates.template10.modules.getColor
import com.anjuros.website.templates.template10.styles.Template10ContainerStyle
import com.anjuros.website.templates.template10.styles.Template10LetterStyle
import com.anjuros.website.templates.template10.styles.Template10SectionPaddingStyle
import com.anjuros.website.templates.template10.styles.Template10TitleStyle
import com.anjuros.website.templates.template10.styles.Template10WatermarkStyle
import com.anjuros.website.templates.template10.styles.template10Vertical
import com.anjuros.website.templates.template10.util.ResKey
import com.anjuros.website.templates.template10.util.Template10CompanyDetails
import com.anjuros.website.templates.template10.util.Template10Constants
import com.anjuros.website.templates.template10.util.Template10Glyphs
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template10ContactSection(showContactForm: Boolean = false) {
    Box(
        modifier = Template10SectionPaddingStyle.toModifier()
            .id(Template10Section.Contact.id)
            .fillMaxWidth()
            .backgroundColor(Template10Theme.Ink.rgb)
            .overflow(Overflow.Hidden),
        contentAlignment = Alignment.Center
    ) {
        // big "way" watermark
        Span(
            attrs = Template10WatermarkStyle.toModifier()
                .align(Alignment.TopEnd)
                .styleModifier {
                    property("margin-right", "-60px")
                    property("margin-top", "-150px")
                    property("pointer-events", "none")
                    property("user-select", "none")
                }
                .template10HeadingFont()
                .fontWeight(FontWeight.ExtraBold)
                .color(Template10Theme.InkWatermark.rgb)
                .toAttrs()
        ) {
            Text(Template10Glyphs.WAY)
        }

        SimpleGrid(
            numColumns = numColumns(base = 1, lg = 2),
            modifier = Template10ContainerStyle.toModifier()
                .position(Position.Relative)
                .zIndex(1)
                .gap(64.px)
                .styleModifier { property("align-items", "center") }
        ) {
            Template10Reveal(modifier = Modifier.fillMaxWidth()) {
                Template10ContactInfo()
            }
            if (showContactForm) {
                Template10Reveal(modifier = Modifier.fillMaxWidth(), delayMs = 150) {
                    Template10Letter()
                }
            }
        }
    }
}

@Composable
private fun Template10ContactInfo() {
    Column(modifier = Modifier.fillMaxWidth().gap(32.px)) {
        Row(
            modifier = Modifier.gap(22.px),
            verticalAlignment = Alignment.Top
        ) {
            Template10Seal(
                modifier = Modifier.flexShrink(0),
                glyph = Template10Glyphs.WELCOME,
                fontSize = 26,
                vertical = true
            )
            Column(modifier = Modifier.gap(14.px)) {
                Template10Eyebrow(
                    text = ResKey.TEMPLATE10_SECTION5,
                    color = Template10Theme.Coral.rgb
                )
                P(
                    attrs = Template10TitleStyle.toModifier()
                        .margin(0.px)
                        .template10HeadingFont()
                        .fontWeight(FontWeight.Bold)
                        .color(Template10Theme.Paper.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE10_CONTACT_TITLE))
                }
            }
        }

        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 2),
            modifier = Modifier.fillMaxWidth().gap(16.px)
        ) {
            Template10ContactCard(
                label = ResKey.TEMPLATE10_CONTACT_CALL,
                value = Template10CompanyDetails.CLIENTS_PHONE_INFO,
                path = "tel:${Template10Constants.CLIENTS_PHONE.replace(" ", "")}"
            )
            Template10ContactCard(
                label = ResKey.TEMPLATE10_CONTACT_WRITE,
                value = Template10CompanyDetails.CLIENTS_EMAIL_INFO,
                path = "mailto:${Template10Constants.CLIENTS_EMAIL}"
            )
        }

        Column(modifier = Modifier.fillMaxWidth()) {
            Template10Venue.entries.forEach { venue ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(topBottom = 16.px)
                        .gap(18.px)
                        .styleModifier {
                            property("border-top", "1px solid ${Template10Theme.InkLine.hex}")
                            if (venue == Template10Venue.entries.last()) {
                                property("border-bottom", "1px solid ${Template10Theme.InkLine.hex}")
                            }
                        },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(
                        modifier = Modifier
                            .size(34.px)
                            .flexShrink(0)
                            .borderRadius(50.percent)
                            .border(width = 1.5.px, style = LineStyle.Solid, color = Template10Theme.Coral.rgb),
                        contentAlignment = Alignment.Center
                    ) {
                        Span(
                            attrs = Modifier
                                .template10HeadingFont()
                                .fontWeight(FontWeight.Bold)
                                .color(Template10Theme.Coral.rgb)
                                .toAttrs()
                        ) {
                            Text(venue.number)
                        }
                    }
                    Span(
                        attrs = Modifier
                            .width(110.px)
                            .flexShrink(0)
                            .template10HeadingFont()
                            .fontSize(20.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template10Theme.Paper.rgb)
                            .toAttrs()
                    ) {
                        AnjurosText(venue.city)
                    }
                    Span(
                        attrs = Modifier
                            .template10BodyFont()
                            .fontSize(15.px)
                            .color(Template10Theme.StoneLight.rgb)
                            .toAttrs()
                    ) {
                        AnjurosText(venue.address)
                    }
                }
            }
        }
    }
}

@Composable
private fun Template10ContactCard(
    label: ResKey,
    value: Template10CompanyDetails,
    path: String
) {
    Link(
        modifier = Modifier.textDecorationLine(TextDecorationLine.None),
        path = path
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .border(width = 1.px, style = LineStyle.Solid, color = Template10Theme.InkBorder.rgb)
                .borderRadius(10.px)
                .padding(20.px)
                .gap(4.px)
        ) {
            Span(
                attrs = Modifier
                    .template10BodyFont()
                    .fontSize(12.px)
                    .fontWeight(FontWeight.Bold)
                    .letterSpacing(0.2.em)
                    .color(Template10Theme.Stone.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(label))
            }
            Span(
                attrs = Modifier
                    .template10HeadingFont()
                    .fontSize(22.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template10Theme.Paper.rgb)
                    .styleModifier { property("word-break", "break-word") }
                    .toAttrs()
            ) {
                AnjurosText(value)
            }
        }
    }
}

/** The contact form, styled as a slightly tilted letter on paper. */
@Composable
private fun Template10Letter() {
    var success by remember { mutableStateOf(false) }

    Column(
        modifier = Template10LetterStyle.toModifier()
            .fillMaxWidth()
            .position(Position.Relative)
            .backgroundColor(Template10Theme.Paper.rgb)
            .borderRadius(4.px)
            .overflow(Overflow.Hidden)
            .boxShadow(offsetY = 30.px, blurRadius = 60.px, color = rgba(0, 0, 0, 0.35))
    ) {
        // red top band
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(10.px)
                .backgroundColor(Template10Theme.Primary.getColor())
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 38.px, right = 32.px, bottom = 32.px, left = 32.px)
                .gap(10.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().gap(16.px),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top
            ) {
                Column(modifier = Modifier.gap(4.px)) {
                    P(
                        attrs = Modifier
                            .margin(0.px)
                            .template10HeadingFont()
                            .fontSize(30.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template10Theme.Ink.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.TEMPLATE10_CONTACT_CARD_TITLE))
                    }
                    P(
                        attrs = Modifier
                            .margin(0.px)
                            .template10BodyFont()
                            .fontSize(14.px)
                            .color(Template10Theme.Muted.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.TEMPLATE10_CONTACT_CARD_TEXT))
                    }
                }
                Span(
                    attrs = Modifier
                        .template10Vertical()
                        .template10HeadingFont()
                        .fontSize(22.px)
                        .fontWeight(FontWeight.ExtraBold)
                        .letterSpacing(0.2.em)
                        .color(Template10Theme.DeepRed.rgb)
                        .toAttrs()
                ) {
                    Text(Template10Glyphs.LETTER)
                }
            }

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .position(Position.Relative),
                contentAlignment = Alignment.Center
            ) {
                ContactForm(
                    isDemo = true,
                    buttonColor = Template10Theme.Primary.getColor(),
                    contactItemsList = listOf(
                        NAME_CONTACT_FORM.copy(index = 0),
                        PHONE_NUMBER_CONTACT_FORM.copy(index = 1),
                        EMAIL_CONTACT_FORM.copy(index = 2),
                        MESSAGE_CONTACT_FORM.copy(index = 3),
                    )
                ) {
                    success = true
                }
                SuccessContactMessage(
                    isDemo = true,
                    showSuccess = success,
                    onClose = { success = false }
                )
            }
        }
    }
}
